import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'lane', 'Lane', [["path",{"d":"M4 6v13","key":"svg-0"}],["path",{"d":"M20 6v13","key":"svg-1"}]]);